import { useEffect, useState } from "react";
import { InputProps } from "./Input";
import StringInput from "./StringInput";


export default function NumberInput(props: InputProps) {
    return StringInput(props);
}